import { sidebarPage } from '../utils/sidebarPageLayout.js';

export class FootballGirlReport {
    constructor(containerId) {
        this.containerId = containerId;
        this.currentPage = 0;
        this.totalPages = 9;
        this.isDragging = false;
        this.startX = 0;
        this.currentTranslate = 0;
        this.prevTranslate = 0;
    }

    init() {
        const el = document.getElementById(this.containerId);
        if (!el) return;

        this.injectStyles();
        this.render();
        this.attachListeners();
    }

    render() {
        const el = document.getElementById(this.containerId);
        
        const pages = [
            // Page 1: Cover
            `
            <div class="fgr-page fgr-page--cover">
                <div class="fgr-pitch-lines"></div>
                <div class="fgr-cover-content">
                    <div class="fgr-logo-large">
                        <img src="/images/logo2.png" alt="Logo">
                        <div class="fgr-ball-glow"></div>
                    </div>
                    <h1>FOOTBALLGIRL.EU</h1>
                    <p class="fgr-tagline">The Home of Female Football</p>
                    <h2 class="fgr-report-title">Q1 2026 Quarterly Report</h2>
                    <p class="fgr-focus">Building the Super App – News • Streaming • Shop • Funding • Games</p>
                    <p class="fgr-date">April 2026</p>
                    <div class="fgr-footer-logo">
                        <img src="/images/logo2.png" alt="Logo"><sup>™</sup>
                    </div>
                </div>
            </div>
            `,
            // Page 2: Executive Summary
            `
            <div class="fgr-page">
                <div class="fgr-page-inner">
                    <div class="fgr-page-header">
                        <img src="/images/logo2.png" class="fgr-mini-logo" alt="Logo">
                        <span class="fgr-page-num">02</span>
                    </div>
                    <div class="fgr-split-layout">
                        <div class="fgr-text-col">
                            <h2>Executive Summary</h2>
                            <p>Footballgirl.eu is the home of female football. It delivers news from the top 16 women’s football leagues in the world, wrapped in our distinctive brand design.</p>
                            <p>This quarter we kept strong user levels while building the major features that turn us into a true super app. We created a Shop, Streaming page, and Funding frontend — now halfway complete and launching on <strong>May 1st, 2026</strong> (just three weeks away), with more exciting updates to follow.</p>
                            <div class="fgr-highlight-box">
                                <h3>Top 3 Achievements</h3>
                                <ul>
                                    <li>Developed and prepared the Shop, Streaming, and Funding pages — the exciting foundations of our super app.</li>
                                <li>Delivered strong backend improvements including automation and database management.</li>
                                <li>Interviewed 11 inspiring women in the game for rich future content.</li>
                            </ul>
                        </div>
                    </div>
                        <div class="fgr-image-col">
                            <div class="fgr-action-photo"></div>
                        </div>
                    </div>
                </div>
            </div>
            `,
            // Page 3: Audience & Vision
            `
            <div class="fgr-page">
                <div class="fgr-page-inner">
                    <div class="fgr-page-header">
                        <img src="/images/logo2.png" class="fgr-mini-logo" alt="Logo">
                        <span class="fgr-page-num">03</span>
                    </div>
                    <div class="fgr-content-narrow">
                        <h2>Our Audience</h2>
                        <p>The vast global fandom of women’s football that is still waiting to be fully celebrated. My dream is to create an iconic global brand for the women’s game — like Disney with Mickey Mouse or McDonald’s with the golden arches.</p>
                        <blockquote class="fgr-quote">
                            "This site matters because it’s a dedicated, evolving hub built by someone who has loved the game since childhood."
                        </blockquote>
                        <p>It offers news, stories, clothes, streaming, funding, games, and connection — all growing through technology right in front of our users.</p>
                        <p>The next quarter introduces our first major revenue stream, powered by streaming and more articles. The Funding feature feels especially meaningful. Once live, we’ll move quickly into Tiago AI chatbot, messaging, and more. I’m genuinely excited watching this platform grow into something warm and alive for our community.</p>
                    </div>
                </div>
            </div>
            `,
            // Page 4: Progress
            `
            <div class="fgr-page">
                <div class="fgr-page-inner">
                    <div class="fgr-page-header">
                        <img src="/images/logo2.png" class="fgr-mini-logo" alt="Logo">
                        <span class="fgr-page-num">04</span>
                    </div>
                    <div class="fgr-content-narrow">
                        <h2>What We Have Done This Quarter</h2>
                        <div class="fgr-grid-stats">
                            <div class="fgr-stat-item">
                                <strong>3X</strong>
                                <span>Page views and sessions tripled in many areas</span>
                            </div>
                            <div class="fgr-stat-item">
                                <strong>11</strong>
                        </div>
                        <div class="fgr-stat-item">
                            <strong>11</strong>
                            <span>Powerful long-form interviews recorded</span>
                        </div>
                    </div>
                    <div class="fgr-progress-list">
                            <div class="fgr-p-item"><strong>New sections prepared:</strong> Shop, Streaming (bringing together video highlights and social content from across leagues), and Funding.</div>
                            <div class="fgr-p-item"><strong>Content:</strong> Covering 9 major leagues with ~9 articles each. Translation features have boosted international traffic, including strong growth from China.</div>
                            <div class="fgr-p-item"><strong>Technical:</strong> Cleaner navigation, backend/database improvements, automation tools, and better comment moderation with user authentication.</div>
                            <div class="fgr-p-item"><strong>Community:</strong> 11 powerful long-form interviews recorded (1–2.5 hours each) — incredible footage ready to bring fresh voices to the platform.</div>
                        </div>
                        <div class="fgr-highlight-box" style="margin-top:30px;">
                            <p><strong>Performance Snapshot:</strong> Page views and sessions have tripled in many areas. Daily active users are higher and more consistent, with visitors exploring significantly more pages per session. We stayed focused on feature development (social growth was paused), but overall momentum feels strong and organic.</p>
                        </div>
                    </div>
                </div>
            </div>
            `,
            // Page 5: Roadmap
            `
            <div class="fgr-page">
                <div class="fgr-page-inner">
                    <div class="fgr-page-header">
                        <img src="/images/logo2.png" class="fgr-mini-logo" alt="Logo">
                        <span class="fgr-page-num">05</span>
                    </div>
                    <div class="fgr-content-narrow">
                        <h2>Why & What's Next</h2>
                        <p>We prioritised the biggest, most transformative features first because they make footballgirl.eu a real super app. Lighter tasks like extra articles can be accelerated once the core is solid.</p>
                        <p>These features solve real gaps: A dedicated streaming hub for our community; Funding tools that connect supporters directly with players and projects; Better global reach through translation and navigation.</p>
                        <div class="fgr-roadmap">
                            <div class="fgr-road-item done"><strong>May 1st, 2026</strong> Major launch of Shop, Streaming, and Funding</div>
                            <div class="fgr-road-item"><strong>Currently in Progress</strong> Games section (football-data quiz and engagement games)</div>
                            <div class="fgr-road-item"><strong>Currently in Progress</strong> Tiago AI chatbot & messaging integration</div>
                        </div>
                        <div class="fgr-highlight-box" style="margin-top:30px;">
                            <h3>Timeline</h3>
                            <p>Technical status is strong — systems are stable and ready for growth.</p>
                        </div>
                    </div>
                </div>
            </div>
            `,
            // Page 6: Future Vision
            `
            <div class="fgr-page">
                <div class="fgr-page-inner">
                    <div class="fgr-page-header">
                        <img src="/images/logo2.png" class="fgr-mini-logo" alt="Logo">
                        <span class="fgr-page-num">06</span>
                    </div>
                    <div class="fgr-content-narrow">
                        <h2>Challenges & Future Vision</h2>
                        <p><strong>Biggest obstacle:</strong> Complex coding issues. We overcame them with daily perseverance and realistic planning. <strong>Positive surprise:</strong> A focused week of hard work consistently delivers visible progress.</p>
                        <p><strong>Key lesson:</strong> Running two features in parallel with dedicated focus days actually speeds everything up. Planning first, then pure execution works best.</p>
                        <div class="fgr-highlight-box">
                            <h3>Future Vision – Next 6 Months</h3>
                            <ul>
                                <li>All league features complete and ready for the new season.</li>
                                <li>Full automations across sections.</li>
                                <li>Triple current user numbers through organic engagement.</li>
                                <li>Launch games and AI features.</li>
                            </ul>
                        </div>
                        <div class="fgr-goal-card">
                            <h3>Expected Impact</h3>
                            <strong>Target: 100,000 Users</strong>
                            <p>We’re creating new fans naturally, increasing visibility and storytelling regardless of the wider industry pace. Expanding into messaging, books, and courses.</p>
                        </div>
                    </div>
                </div>
            </div>
            `,
            // Page 7: Financials
            `
            <div class="fgr-page">
                <div class="fgr-page-inner">
                    <div class="fgr-page-header">
                        <img src="/images/logo2.png" class="fgr-mini-logo" alt="Logo">
                        <span class="fgr-page-num">07</span>
                    </div>
                    <div class="fgr-content-narrow">
                        <h2>Other Projects & Financials</h2>
                        <p><strong>Other Initiatives:</strong> We’ve started client work through our management service and co-founding companies to bring new products to market (first launches expected next month). This brings more eyes to our ecosystem through players and their networks.</p>
                        <p><strong>Financial Summary:</strong> Costs remained very low this quarter. The project stays sustainable while free for all users. We are actively exploring funding, sponsorships, and grants to accelerate growth.</p>
                        <div class="fgr-highlight-box" style="border-left: 4px solid #ef4444;">
                            <h3>Risks & Mitigation</h3>
                            <p>Main risk: Balancing feature completion with content production. We mitigate with disciplined one-by-one execution and strong planning. More resources would help us move even faster.</p>
                        </div>
                    </div>
                </div>
            </div>
            `,
            // Page 8: Back Cover
            `
            <div class="fgr-page fgr-page--cover">
                <div class="fgr-pitch-lines"></div>
                <div class="fgr-cover-content">
                    <div class="fgr-logo-large">
                        <img src="/images/logo2.png" alt="Logo">
                    </div>
                    <h1>Footballgirl.eu</h1>
                    <p class="fgr-tagline">The Home of Female Football</p>
                    <div class="fgr-highlight-box" style="background: transparent; color: white;">
                        <p>Thank you for reading our Q1 2026 journey.</p>
                        <p>We’re building something special — come grow with us.</p>
                    </div>
                    <p class="fgr-date" style="margin-top:40px;">© 2026 Footballgirl.eu – All rights reserved</p>
                </div>
            </div>
            `,
            // Page 9: Investor Q&A Appendix
            `
            <div class="fgr-page fgr-page--qa">
                <div class="fgr-page-inner">
                    <div class="fgr-page-header">
                        <img src="/images/logo2.png" class="fgr-mini-logo" alt="Logo">
                        <span class="fgr-page-num">Appendix</span>
                    </div>
                    <div class="fgr-qa-container">
                        <h2>Investor Q&A — April 2026</h2>
                        
                        <div class="fgr-qa-item">
                            <strong>Traction & Growth: What are your current key metrics and how have they trended?</strong>
                            <p>Answer: The numbers have grown magnificently. Since November we’ve seen them double every month, and now page views are increasing even more strongly. Users are spending more time exploring, with sessions and pages per visit rising nicely. It feels like real organic momentum is building.</p>
                    <div class="fgr-qa-item">
                        <strong>Traction & Growth: What are your current key metrics and how have they trended?</strong>
                        <p>Answer: The numbers have grown magnificently. Since November we’ve seen them double every month, and now page views are increasing even more strongly. Users are spending more time exploring, with sessions and pages per visit rising nicely. It feels like real organic momentum is building.</p>
                    </div>

                    <div class="fgr-qa-item">
                        <strong>Product Vision: Can you walk us through the full product roadmap and what the super app looks like in 12–18 months?</strong>
                        <p>Answer: We’re already live and iterating, so there isn’t a traditional “MVP” phase anymore. Our aim is to have the full super app working smoothly within the next 6 months. After that we’ll spend the remaining time polishing navigation, improving CSS and design details, and making every “room” in the app feel warm and inviting — like finishing and decorating a beautiful hotel.</p>
                    </div>

                    <div class="fgr-qa-item">
                        <strong>User Acquisition: How are you acquiring users and what is your most effective channel / CAC?</strong>
                        <p>Answer: Right now we’re fully focused on iteration and perfecting the product. We prefer not to share exact acquisition cost numbers publicly at this stage. This period is essentially a rich beta phase — once the full platform is finished and we add proper trackers, we’ll see clearer data flows and can optimise acquisition more strategically.</p>
                    </div>

                    <div class="fgr-qa-item">
                        <strong>Market Opportunity: How big is the addressable market and what share do you realistically believe you can capture in 3–5 years?</strong>
                        <p>Answer: The opportunity is enormous and growing fast. Global women’s sports revenues are projected to exceed $3 billion in 2026, with the women’s football fanbase expected to reach over 800 million by 2030 (a 38% increase this decade). I believe we can capture a significant share. Just two well-executed big moves — one online and one offline — could accelerate our position dramatically in this exciting, still-underserved space.</p>
                    </div>

                    <div class="fgr-qa-item">
                        <strong>Differentiation: What makes footballgirl.eu fundamentally different and what is your unfair advantage?</strong>
                        <p>Answer: Our biggest unfair advantage is who we are and our deep, faithful history with the sport. This isn’t just another media site — it comes from genuine love and lived experience. Many competitors lack that same singular purpose and long-term motivation, which naturally limits how deeply they can connect with the community.</p>
                    </div>

                    <div class="fgr-qa-item">
                        <strong>Monetization Strategy: What is your detailed plan and timeline to start generating income?</strong>
                        <p>Answer: Revenue will roll out in one coordinated phase across all sections of the platform. This will create natural spaces for advertisers, sponsorships, marketplace sales (via the shop), and other streams. We’re timing it with the new traffic from streaming and increased content so everything grows together.</p>
                    </div>

                    <div class="fgr-qa-item">
                        <strong>Competitive Landscape: Who are your top 3 competitors and how do you plan to win?</strong>
                        <p>Answer: Because of our unique outlook and deep-rooted motivation, we don’t see direct general competition in the same way. By the end of this year the differentiator will be clearly visible to everyone. We’re building something warmer, more engaging, and more holistic than what currently exists.</p>
                    </div>

                    <div class="fgr-qa-item">
                        <strong>Content & Events Strategy: How do you source and create content/events and how will you scale without exploding costs?</strong>
                        <p>Answer: Automation is playing a big role here. We’re setting up smart systems that let us scale content production efficiently while keeping quality high and costs under control.</p>
                    </div>

                    <div class="fgr-qa-item">
                        <strong>Technical Roadmap: What is the current tech stack and how scalable is it? Any major changes planned?</strong>
                        <p>Answer: The stack is very scalable and we’re deliberately aligning the backend for future growth and easy measurement. We’re heading toward React on the front end with no major re-architecture needed — just steady improvements that support expansion.</p>
                    </div>

                    <div class="fgr-qa-item">
                        <strong>Community & Engagement: How engaged are users today and what features will increase retention?</strong>
                        <p>Answer: Engagement is already improving — users are viewing more pages and returning more consistently. The features we’re building next (games, AI chatbot Tiago, messaging, and richer streaming choices) are specifically designed to turn one-time visitors into daily, loyal fans who keep coming back for the full experience.</p>
                    </div>

                    <div class="fgr-qa-item">
                        <strong>Risks & Challenges: What are the biggest risks in the next 12 months and how are you mitigating them?</strong>
                        <p>Answer: The main risks are around timely content production while we finish big features, and ensuring smooth launches. We’re mitigating them with disciplined one-by-one execution, strong upfront planning, and staying patient. Additional resources would help reduce these risks further.</p>
                    </div>

                    <div class="fgr-qa-item">
                        <strong>Milestones & KPIs: What are the 3–5 most important milestones in the next 6–12 months?</strong>
                        <p>Answer: 1) Full launch and iteration of Shop, Streaming, Funding, Games & AI features (by end of 6 months). 2) Triple current user numbers through organic engagement. 3) Accelerate content across more leagues. 4) Reach ~100k users within 12 months with the final 6 months focused on promotion. Success will be measured by usage metrics, retention, and engagement depth.</p>
                    </div>

                    <div class="fgr-qa-item">
                        <strong>Exit Potential / Long-term Vision: What does success look like in 5 years?</strong>
                        <p>Answer: Success means becoming the dominant, warm home for the global women’s football community — a vibrant super app where fans connect, engage, shop, fund projects, play, and grow with the sport. We have plans to stay in control and continue building rather than selling early. The goal is to grow something lasting and meaningful, like the iconic brands that define their spaces.</p>
                    </div>
                        <div class="fgr-pdf-footer">
                            <button class="fg-btn fg-btn--primary" id="fgr-download-pdf">Download PDF Version</button>
                        </div>
                    </div>
                </div>
            </div>
            `
        ];

        const main = `
            <div class="fgr-viewer">
                <button class="fgr-fullscreen-btn" id="fgr-fullscreen-btn" title="Fullscreen presentation">⛶</button>
                <button class="fgr-exit-btn" id="fgr-exit-btn" title="Exit Fullscreen">✕</button>
                <div class="fgr-track" id="fgr-track" style="width: ${pages.length * 100}%;">
                    ${pages.join('')}
                </div>
                
                <div class="fgr-navigation">
                    <div class="fgr-nav-arrows">
                        <button class="fgr-arrow" id="fgr-prev" style="visibility: hidden;">←</button>
                        <div class="fgr-dots">
                            ${pages.map((_, i) => `<div class="fgr-dot ${i === 0 ? 'active' : ''}"></div>`).join('')}
                        </div>
                        <button class="fgr-arrow" id="fgr-next">→</button>
                    </div>
                    <div class="fgr-counter">${this.currentPage + 1} of ${this.totalPages}</div>
                </div>
            </div>
        `;

        el.innerHTML = sidebarPage({ title: '', main, wide: true });
    }

    injectStyles() {
        const styleId = 'fgr-styles';
        if (document.getElementById(styleId)) return;
        const css = `
            .fgr-viewer { position: relative; width: 100%; height: 90vh; overflow: hidden; background: #fff; border-radius: 16px; box-shadow: var(--shadow-lg); cursor: grab; }
            .fgr-viewer.is-fullscreen { position: fixed; inset: 0; width: 100vw; height: 100vh; z-index: 99999; border-radius: 0; }
            
            .fgr-viewer:active { cursor: grabbing; }
            .fgr-track { display: flex; height: 100%; transition: transform 0.5s cubic-bezier(0.2, 1, 0.3, 1); }
            .fgr-page { flex: 1; height: 100%; padding: 60px 60px 160px; position: relative; overflow-y: auto; background: #fff; color: #000; }
            .fgr-page-inner { max-width: 1000px; margin: 0 auto; width: 100%; }
            
            .fgr-fullscreen-btn {
                position: absolute; top: 20px; right: 20px; z-index: 100;
                background: rgba(0, 0, 0, 0.3); color: white; border: none;
                width: 40px; height: 40px; border-radius: 50%; cursor: pointer;
                font-size: 1.2rem; display: flex; align-items: center; justify-content: center;
                transition: background 0.2s, transform 0.2s;
            }
            .fgr-fullscreen-btn:hover { background: rgba(0, 0, 0, 0.6); transform: scale(1.1); }
            
            .fgr-exit-btn {
                position: absolute; top: 20px; right: 20px; z-index: 100001;
                background: rgba(0, 0, 0, 0.5); color: white; border: none;
                width: 44px; height: 44px; border-radius: 50%; cursor: pointer;
                font-size: 1.5rem; display: none; align-items: center; justify-content: center;
                transition: background 0.2s, transform 0.2s;
            }
            .fgr-exit-btn:hover { background: rgba(0, 0, 0, 0.8); transform: scale(1.1); }

            .fgr-viewer.is-fullscreen .fgr-exit-btn { display: flex; }
            .fgr-viewer.is-fullscreen .fgr-fullscreen-btn { display: none; }

            /* Cover Page */
            .fgr-page--cover { background: #000; color: #fff; text-align: center; display: flex; align-items: center; justify-content: center; padding: 0; }
            .fgr-pitch-lines { position: absolute; inset: 0; background-image: linear-gradient(rgba(0, 255, 136, 0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(0, 255, 136, 0.05) 1px, transparent 1px); background-size: 50px 50px; mask-image: radial-gradient(circle at center, black, transparent 80%); }
            .fgr-logo-large { position: relative; margin-bottom: 40px; }
            .fgr-logo-large img { width: 180px; filter: drop-shadow(0 0 20px rgba(0, 122, 255, 0.4)); }
            .fgr-ball-glow { position: absolute; bottom: 40px; right: 40px; width: 20px; height: 20px; background: var(--fitness-vibrant-pink); border-radius: 50%; box-shadow: 0 0 30px var(--fitness-vibrant-pink); }
            .fgr-report-title { color: #007AFF; margin-top: 40px; text-transform: uppercase; letter-spacing: 2px; }
            
            /* Content Styles */
            .fgr-page-header { display: flex; justify-content: space-between; margin-bottom: 40px; }
            .fgr-mini-logo { height: 30px; }
            .fgr-page-num { font-weight: 800; color: #ddd; }
            .fgr-split-layout { display: grid; grid-template-columns: 1fr 1fr; gap: 40px; }
            .fgr-action-photo { background: #f0f2f5; border-radius: 12px; height: 100%; min-height: 300px; }
            .fgr-highlight-box { background: #f8f9fa; border-radius: 12px; padding: 24px; margin-top: 24px; }
            .fgr-quote { font-size: 1.5rem; font-weight: 800; border-left: 4px solid var(--fitness-vibrant-pink); padding-left: 24px; margin: 40px 0; color: #000; }
            .fgr-grid-stats { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin: 32px 0; }
            .fgr-stat-item { background: #000; color: #fff; padding: 24px; border-radius: 12px; }
            .fgr-stat-item strong { font-size: 2rem; display: block; color: var(--fitness-electric-blue); }
            .fgr-roadmap { display: flex; flex-direction: column; gap: 12px; margin-top: 24px; }
            .fgr-road-item { padding: 16px; border-radius: 8px; border: 1px solid #eee; position: relative; }
            .fgr-road-item.done::after { content: '✓'; position: absolute; right: 16px; color: #22c55e; font-weight: 800; }
            
            /* Navigation Bar */
            .fgr-navigation { position: absolute; bottom: 0; left: 0; right: 0; padding: 20px; background: rgba(255,255,255,0.9); backdrop-filter: blur(10px); display: flex; flex-direction: column; align-items: center; gap: 10px; border-top: 1px solid #eee; }
            .fgr-nav-arrows { display: flex; align-items: center; gap: 40px; }
            .fgr-arrow { background: none; border: none; font-size: 1.5rem; cursor: pointer; color: #007AFF; font-weight: 800; }
            .fgr-dots { display: flex; gap: 8px; }
            .fgr-dot { width: 8px; height: 8px; border-radius: 50%; background: #ddd; transition: 0.3s; }
            .fgr-dot.active { background: #007AFF; transform: scale(1.3); }
            .fgr-counter { font-size: 0.75rem; font-weight: 700; color: #888; text-transform: uppercase; }

            .fgr-pdf-footer { margin-top: 40px; text-align: center; }

            @media (max-width: 768px) {
                .fgr-split-layout { grid-template-columns: 1fr; }
                .fgr-page { padding: 30px 20px 160px; }
            }
        `;
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = css;
        document.head.appendChild(style);
    }

    attachListeners() {
        const track = document.getElementById('fgr-track');
        const prevBtn = document.getElementById('fgr-prev');
        const nextBtn = document.getElementById('fgr-next');
        const viewer = document.querySelector('.fgr-viewer');

        const updateUI = () => {
            const translate = this.currentPage * -100 / this.totalPages;
            track.style.transform = `translateX(${translate}%)`;
            
            // Update Arrows
            prevBtn.style.visibility = this.currentPage === 0 ? 'hidden' : 'visible';
            nextBtn.style.visibility = this.currentPage === this.totalPages - 1 ? 'hidden' : 'visible';

            // Update Dots
            document.querySelectorAll('.fgr-dot').forEach((dot, i) => {
                dot.classList.toggle('active', i === this.currentPage);
            });

            // Update Counter
            document.querySelector('.fgr-counter').textContent = `${this.currentPage + 1} of ${this.totalPages}`;
        };

        nextBtn.onclick = () => { if(this.currentPage < this.totalPages - 1) { this.currentPage++; updateUI(); } };
        prevBtn.onclick = () => { if(this.currentPage > 0) { this.currentPage--; updateUI(); } };

        // Draggable Logic
        const touchStart = (e) => {
            this.isDragging = true;
            this.startX = e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
        };

        const touchEnd = () => {
            this.isDragging = false;
        };

        const touchMove = (e) => {
            if (!this.isDragging) return;
            const currentX = e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
            const diff = currentX - this.startX;

            if (Math.abs(diff) > 100) {
                if (diff > 0 && this.currentPage > 0) {
                    this.currentPage--;
                    this.isDragging = false;
                    updateUI();
                } else if (diff < 0 && this.currentPage < this.totalPages - 1) {
                    this.currentPage++;
                    this.isDragging = false;
                    updateUI();
                }
            }
        };

        viewer.addEventListener('mousedown', touchStart);
        viewer.addEventListener('touchstart', touchStart);
        viewer.addEventListener('mouseup', touchEnd);
        viewer.addEventListener('touchend', touchEnd);
        viewer.addEventListener('mousemove', touchMove);
        viewer.addEventListener('touchmove', touchMove);

        // Fullscreen Logic
        const fsBtn = document.getElementById('fgr-fullscreen-btn');
        const exitBtn = document.getElementById('fgr-exit-btn');
        
        const toggleFullscreen = () => {
            viewer.classList.toggle('is-fullscreen');
            document.body.style.overflow = viewer.classList.contains('is-fullscreen') ? 'hidden' : '';
        };

        if (fsBtn) fsBtn.onclick = (e) => { e.stopPropagation(); toggleFullscreen(); };
        if (exitBtn) exitBtn.onclick = (e) => { e.stopPropagation(); toggleFullscreen(); };

        const handleEsc = (e) => {
            if (e.key === 'Escape' && viewer.classList.contains('is-fullscreen')) {
                toggleFullscreen();
            }
        };
        window.addEventListener('keydown', handleEsc);

        document.getElementById('fgr-download-pdf')?.addEventListener('click', () => {
            // This triggers the system dialog where "Save as PDF" can be selected
            window.print();
        });
    }
}